import { render, staticRenderFns } from "./SidebarManage.vue?vue&type=template&id=930ae06a&"
import script from "./SidebarManage.vue?vue&type=script&lang=js&"
export * from "./SidebarManage.vue?vue&type=script&lang=js&"
import style0 from "./SidebarManage.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports